/**
 * Die Antwort-Tiefe — EINE Quelle für Server, Einstellungs-Filter und
 * Oberfläche. (27.09.2026, Tickets 2657/2671)
 *
 * Martin, 26.09.2026: *„Ich möchte eine Art Kompakt-Antwortmodus haben …
 * nur den Kern“* — und eine Stunde später: drei Stufen statt zwei, auch als
 * Regler, nicht nur per Zuruf. Am 01.10.2026 (Ticket 2889) kam eine vierte
 * dazu, für ganz schnelle Sachen.
 *
 *   ultrakurz     — ein einziger Satz: nur das Ergebnis oder die eine Frage
 *   kurz          — nur der Kern (der frühere Kompakt-Modus)
 *   normal        — wie gewohnt (Vorgabe; auch, wenn nichts gesetzt ist)
 *   ausfuehrlich  — gern mit Herleitung, Beispielen und Zusammenhängen
 *
 * ⚠️ Hier stehen nur die Werte. Wie jede Stufe am Zug wirkt, steht in
 *    server/antwort-tiefe.ts; der Filter der Einstellungen
 *    (server/settings-sanitize.ts) lässt genau diese vier durch.
 */
export const ANTWORT_TIEFEN = ["ultrakurz", "kurz", "normal", "ausfuehrlich"] as const;

export type AntwortTiefe = (typeof ANTWORT_TIEFEN)[number];

/** Was gilt, solange nichts gesetzt ist. */
export const ANTWORT_TIEFE_VORGABE: AntwortTiefe = "normal";

/** Ist das eine der vier Stufen? */
export function istAntwortTiefe(x: unknown): x is AntwortTiefe {
  return typeof x === "string" && (ANTWORT_TIEFEN as readonly string[]).includes(x);
}

/**
 * Die Stufen, die KURZ antworten wollen — EINE Stelle für alles, was bei
 * „kurz“ etwas lässt oder durchsetzt (keine Überbrückungssätze vorab, die
 * feste Server-Sperre aus Ticket 2839). (01.10.2026, Ticket 2889)
 *
 * ⚠️ Wer die Stufe einzeln mit „kurz“ vergleicht, übersieht „ultrakurz“ — die kürzere
 *    Stufe fiele dann auf das Verhalten von „normal“ zurück.
 */
export const KURZE_STUFEN: readonly AntwortTiefe[] = ["ultrakurz", "kurz"];

/** Will diese Stufe kurz antworten (kurz oder ultrakurz)? */
export function istKurzeStufe(stufe: unknown): boolean {
  return typeof stufe === "string" && (KURZE_STUFEN as readonly string[]).includes(stufe);
}
